import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';
import {ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'typeface-inter';
import './App.css';
import AppRoutes from './AppRoutes';
import { message } from 'antd';
import GlobalErrorModel from "./components/GlobalErrorModel";

function App() {

  message.config({
    duration:3,
    maxCount: 1,
    rtl: false,
    prefixCls:'my-message'
  });


  return (
    <BrowserRouter basename='/'>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={4000}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <AppRoutes />
        <ToastContainer
          style={{ position: 'fixed', top:160, right: 50 }}
          position="top-right"
          autoClose={5000}
          limit={1}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          theme="light"
          />
      </SnackbarProvider>
      
      <GlobalErrorModel/>

    </BrowserRouter>
  );
}

export default App;
